import { AxiosPost, AxiosGet } from "../AxiosWrapper";
import { MANAGEMENT_SERVICE_URL } from "../../constants/ServiceUrls";

export const getDocumentTypesForAdmin = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/DocumentType/GetDocumentTypesForAdmin`
  );
};
export const getDocumentTypes = (requestType) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/DocumentType/GetDocumentTypes`,
    {
      requestType: requestType,
    }
  );
};

export const getCustomerMetadataTypes = () => {
  return AxiosGet(
    `${MANAGEMENT_SERVICE_URL}api/DocumentType/GetCustomerMetadataTypes`
  );
};

export const upsertDocumentType = (values) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/DocumentType/UpsertDocumentType`,
    values
  );
};

export const deleteDocumentType = (id) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/DocumentType/DeleteDocumentType`,
    {
      id: id,
    }
  );
};

export default {
  getDocumentTypesForAdmin,
  getDocumentTypes,
  getCustomerMetadataTypes,
  upsertDocumentType,
  deleteDocumentType,
};
